import InventoryTransfersRoot from '../components/micro-front-ends/InventoryTransfers'
import InventoryStatusRoot from '../components/micro-front-ends/InventoryStatus'
import InventoryOptimizationRoot from '../components/micro-front-ends/InventoryOptimization'

export default [
  {
    path: '/inventory-transfers*',
    meta: { showSideNav: true },
    name: 'InventoryTransfers',
    component: InventoryTransfersRoot
  },
  {
    path: '/inventory-status*',
    meta: { showSideNav: true },
    name: 'InventoryStatus',
    component: InventoryStatusRoot
  },
  {
    path: '/distribution-plan*',
    meta: { showSideNav: false },
    name: 'DistributionPlan',
    component: InventoryOptimizationRoot
  }
]
